import styled from "styled-components";

export const WheelOfJackpotbetDialogDefaultBox = styled.div`
    position: relative;
    width: 90vw;
    max-width: 640px;
    @media ${({theme}) => `${theme.mediaQuery.mAndBelow} and ${theme.mediaQuery.landscape}`} {
        padding-top: 22px;
        padding-bottom: 14px;
    }
    padding: 48px 24px 24px 24px;
    overflow: hidden;

    background-image: linear-gradient(175.08deg, #9747FF 3.9%, #22004D 95.98%);
  
    box-shadow: 0px -1px 24px 8px #FF77F133 inset, 0px 0px 4px 0px #83FF00BF inset, 0px 16px 48px 0px #00000038;
    /* border-radius: 10px; */

    border: 1px solid #6D6D6D;

    @media ${({theme}) => theme.mediaQuery.portrait} {
        max-width: 333px;
    }

    margin-top: 25px;
    border-radius: 10px;
`;